
<div *appIsGranted="['TOOLS_COMMANDS_INFO', 'TOOLS_COMMANDS_INFO', 'READ']">
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <h4>Informações dos comandos</h4>
        </div>
      </div>
      <div></div>
    </div>
    <div class="card-body">
      <div class="row d-flex">
        <div class="col">
          <label>Comando</label>
          <div class="mb-1 row">
            <input
              class="form-control"
              type="text"
              id="command-input-text"
              placeholder="Digite para filtrar"
              [(ngModel)]="commandFilterName"
              (ngModelChange)="filter()"
            />
          </div>
        </div>
        <div class="col">
          <label>Seleção de comandos</label>
          <ng-select
            class="w-100"
            id="commandSelect"
            [(ngModel)]="commandFilterNameSelect"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="filter()"
            [multiple]="true"
            placeholder="Selecione um comando"
          >
            <ng-container *ngFor="let command of getCommandName(commandInfo)">
              <ng-option [value]="command"> {{ command }}</ng-option>
            </ng-container>
          </ng-select>
        </div>
        <div class="col">
          <label>Dispositivo</label>
          <ng-select
            class="w-100"
            id="commandDeviceModelSelect"
            [(ngModel)]="commandFilterDeviceModel"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="filter()"
            [multiple]="true"
            placeholder="Selecione um dispositivo"
          >
            <ng-container *ngFor="let device of deviceModels">
              <ng-option [value]="device.dispositivoModelo">
                {{ device.dispositivoModelo }}</ng-option
              >
            </ng-container>
          </ng-select>
        </div>
        <div class="col">
          <label>Canal de envio</label>
          <ng-select
            class="w-100"
            id="channelSendSelect"
            [(ngModel)]="commandFilterChannelSendSelect"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="filter()"
            [multiple]="true"
            placeholder="Selecione um modo de envio"
          >
            <ng-container
              *ngFor="let canalEnvio of canalEnvioEnum; let i = index"
            >
              <ng-option [value]="i + 1"> {{ canalEnvio }}</ng-option>
            </ng-container>
          </ng-select>
        </div>
        <div class="col">
          <label>Sistemas</label>
          <ng-select
            class="w-100"
            id="systemSelect"
            [(ngModel)]="commandFilterSystemsSelect"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="filter()"
            [multiple]="true"
            placeholder="Selecione um comando"
          >
            <ng-container *ngFor="let system of systems">
              <ng-option [value]="system"> {{ system }}</ng-option>
            </ng-container>
          </ng-select>
        </div>
      </div>

      <div class="card align-items-center" *ngIf="circularProgressiveWait">
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!-- <pre [innerHTML]="tableSupplierHTMLString"></pre> -->
      <p id="table_supplier"></p>
    </div>
  </div>
</div>


<div class="card overflow-auto">
  <div class="m-2" style="width: fit-content">
    <button 
      class="btn btn-primary btn-sm"
      *appIsGranted="['TOOLS_COMMANDS_INFO', 'TOOLS_COMMANDS_INFO', 'READ']"
      (click)="changeViewMode()">
      Alterar modo de visualização
    </button>
  </div>

  <ng-container *ngIf="viewMode == 1">
    <div class="card-body">
      <table class="table table-fit table-bordered">
        <thead class="table-primary">
          <tr>
            <th class="text-center" scope="col">Comando</th>
            <th class="text-center" scope="col">Canal Envio</th>
            <th class="text-center" scope="col">Dispositivos</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let item of getCommandName(commandInfoFilter);
              let i = index
            "
            ><tr>
              <td>
                {{ item }}
              </td>
              <td>
                <div class="badge bg-warning ms-2">
                  {{ getChannelSend(commandInfoFilter, item) }}
                </div>
              </td>
              <td>
                <ng-container
                  *ngFor="
                    let itemFilter of filterCommandByName(
                      commandInfoFilter,
                      item
                    )
                  "
                  ><ng-container *ngIf="itemFilter.dispositivoModeloId != 0">
                    <button
                      *appIsGranted="[
                        'TOOLS_COMMANDS_INFO',
                        'TOOLS_COMMANDS_INFO',
                        'UPDATE'
                      ]"
                      class="badge bg-success ms-2"
                      placement="left"
                      [ngbTooltip]="prepareTooltip(itemFilter)"
                      (click)="updateModal(itemFilter, modalUpdateItem)"
                    >
                      {{ itemFilter.dispositivoModelo }}
                    </button>
                  </ng-container>
                </ng-container>
                <button
                  *appIsGranted="[
                    'TOOLS_COMMANDS_INFO',
                    'TOOLS_COMMANDS_INFO',
                    'CREATE'
                  ]"
                  class="badge bg-success ms-2"
                  (click)="
                    newModal(
                      modalNewItem,
                      filterCommandByName(commandInfoFilter, item)[0]
                    )
                  "                  
                >
                  +
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>
  <ng-container *ngIf="viewMode == 2">
    <div class="card-header"><h6>Lista dos comandos</h6></div>

    <div class="card-body">
      <table class="table table-fit table-bordered">
        <thead class="table-primary">
          <tr>
            <th class="text-center" scope="col">Comando</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let item of getCommandName(commandInfoFilter);
              let i = index
            "
          >
            <tr>
              <td class="text-center" scope="row">
                <div class="row">
                  <div class="col-md-11">
                    <ngb-accordion #acc="ngbAccordion">
                      <ngb-panel id="static-1">
                        <ng-template ngbPanelTitle class="accordion-header">
                          <h2 class="accordion-header" id="gen-ques-headingOne">
                            <button
                              class="accordion-button text-align-center text-center"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#gen-ques-collapseOne"
                              aria-expanded="false"
                              aria-controls="gen-ques-collapseOne"
                            >
                              <div class="d-inline">
                                <div>{{ item }}</div>
                                <div class="badge bg-warning ms-2">
                                  {{ getChannelSend(commandInfoFilter, item) }}
                                </div>
                              </div>
                              <ng-container
                                *ngFor="
                                  let itemFilter of filterCommandByName(
                                    commandInfoFilter,
                                    item
                                  )
                                "
                              >
                                <div class="badge bg-success ms-2">
                                  {{ itemFilter.dispositivoModelo }}
                                </div>
                              </ng-container>
                            </button>
                          </h2>
                        </ng-template>
                        <ng-template ngbPanelContent>
                          <table
                            class="table table-fit table-bordered table-hover"
                          >
                            <thead class="table-primary">
                              <tr>
                                <th class="text-center" scope="col">
                                  Modelo de dispositivo
                                </th>
                                <th class="text-center" scope="col">Sistema</th>
                                <th class="text-center" scope="col">
                                  Observacao
                                </th>
                                <th class="text-center" scope="col">
                                  Tem Parametro?
                                </th>
                                <th class="text-center" scope="col">
                                  Qtd Parametro
                                </th>
                                <th class="text-center" scope="col">Exemplo</th>
                                <th class="text-center" scope="col">Ação</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="
                                  let itemFilter of filterCommandByName(
                                    commandInfoFilter,
                                    item
                                  )
                                "
                              >
                                <ng-container
                                  *ngIf="itemFilter.dispositivoModeloId != 0"
                                >
                                  <tr>
                                    <td class="text-center" scope="row">
                                      {{ itemFilter.dispositivoModelo }}
                                    </td>
                                    <td scope="row">
                                      <div
                                        *ngFor="
                                          let itemSystem of item.sistemaAux
                                        "
                                      >
                                        <!-- class="badge bg-warning ms-2" -->
                                        T
                                        {{ itemSystem }}
                                      </div>
                                    </td>
                                    <td class="text-center" scope="row">
                                      <span
                                        [innerHTML]="
                                          sanitizerHTML(
                                            itemFilter.observacaoHTML
                                          )
                                        "
                                      >
                                      </span>
                                    </td>
                                    <td class="text-center" scope="row">
                                      {{ itemFilter.valor }}
                                    </td>
                                    <td class="text-center" scope="row">
                                      {{ itemFilter.quantidadeValor }}
                                    </td>
                                    <td class="text-center" scope="row">
                                      {{ itemFilter.exemplo }}
                                    </td>
                                    <td class="text-center" scope="row">
                                      <button
                                        class="btn btn-primary"
                                        *appIsGranted="[
                                          'TOOLS_COMMANDS_INFO',
                                          'TOOLS_COMMANDS_INFO',
                                          'UPDATE'
                                        ]"
                                        (click)="
                                          updateModal(
                                            itemFilter,
                                            modalUpdateItem
                                          )
                                        "
                                      >
                                        Editar
                                      </button>
                                    </td>
                                  </tr>
                                </ng-container>
                              </ng-container>
                            </tbody>
                          </table>
                        </ng-template>
                      </ngb-panel>
                    </ngb-accordion>
                  </div>
                  <div class="col-md-1">
                    <i
                      *appIsGranted="[
                        'TOOLS_COMMANDS_INFO',
                        'TOOLS_COMMANDS_INFO',
                        'CREATE'
                      ]"
                      ngbTooltip="Adicionar novo modelo"
                      class="fa fa-plus-square"
                      style="cursor: pointer; color: green"
                      aria-hidden="true"
                      (click)="
                        newModal(
                          modalNewItem,
                          filterCommandByName(commandInfoFilter, item)[0]
                        )
                      "
                    ></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<!-- Dialog Update -->
<ng-template #modalUpdateItem let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Atualizar um item</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <form id="formModelSelect" data-toggle="validator" role="form">
      <div class="card ms-2">
        <label>Modelo</label>
        <div>{{ commandInfoSelect[0].dispositivoModelo }}</div>
      </div>
      <div class="row d-flex">
        <div class="col">
          <div class="row mb-3">
            <label>Selecione um Sistema</label>
            <div class="col-8">
              <div class="form-grouping">
                <ng-select
                  id="systemSelect"
                  [(ngModel)]="commandInfoSelect[0].sistemaAux"
                  [ngModelOptions]="{ standalone: true }"
                  [multiple]="true"
                >
                  <ng-option *ngFor="let system of systems" [value]="system">
                    {{ system }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row mb-3">
            <label>Selecione um Canal de envio</label>
            <div class="col-8">
              <div class="form-grouping">
                <ng-select
                  id="systemSelect"
                  [(ngModel)]="commandInfoSelect[0].canalEnvioId"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <ng-option
                    *ngFor="let canalEnvio of canalEnvioEnum; let i = index"
                    [value]="i + 1"
                  >
                    {{ canalEnvio }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col">Copiar do modelo</div>
        <div class="col">
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="ngIfCopyModel"
            checked="true"
            unchecked="false"
          />
        </div>
        <ng-container *ngIf="ngIfCopyModel">
          <div class="col">
            <div class="form-grouping">
              <ng-select
                id="copyModelSelect"
                (change)="copyModel($event, commandInfoSelect[0].nome)"
              >
                <ng-option
                  *ngFor="
                    let copyModel of getOtherItemsSameCommand(
                      commandInfo,
                      commandInfoSelect[0].nome
                    )
                  "
                >
                  {{ copyModel }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="form-grouping mb-2">
        <label for="formObservation" class="control-label">Observacao</label>
        <textarea
          id="formObservation"
          class="form-control"
          placeholder="Digite a observacao"
          type="text"
          name="itemObservation"
          [(ngModel)]="commandInfoSelect[0].observacao"
        >
        </textarea>
      </div>
      <div class="form-grouping">
        <label for="formObservationHTML" class="control-label"
          >ObservacaoHTML</label
        >

        <textarea
          id="formObservationHTML"
          class="form-control"
          placeholder="Digite a observacao HTML"
          type="text"
          name="itemObservationHTML"
          [(ngModel)]="commandInfoSelect![0].observacaoHTML"
        >
        </textarea>
        <div class="card mb-2">
          <span
            [innerHTML]="sanitizerHTML(commandInfoSelect![0].observacaoHTML)"
          >
          </span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="form-grouping m-2">
            <label for="formHasParam" class="control-label"
              >Tem parâmetro?</label
            >
            <input
              class="ms-2"
              type="checkbox"
              name="itemHasParam"
              [(ngModel)]="commandInfoSelect[0].valor"
            />
          </div>
        </div>
        <ng-container *ngIf="commandInfoSelect[0].valor">
          <div class="col">
            <div class="form-grouping m-2">
              <label for="formQtdParam" class="control-label"
                >Quantos parâmetros</label
              >
              <input
                type="number"
                class="form-control"
                name="itemQtdParam"
                [(ngModel)]="commandInfoSelect[0].quantidadeValor"
              />
            </div>
          </div>
        </ng-container>
      </div>
      <div class="row mb-3">
        <div class="form-grouping mb-2">
          <label for="formExemplo" class="control-label">Exemplo</label>
          <input
            id="formExample"
            class="form-control"
            placeholder="Digite um exemplo se houver"
            type="text"
            name="itemExample"
            [(ngModel)]="commandInfoSelect[0].exemplo"
          />
        </div>
      </div>

      <button
        class="btn btn-sm btn-success align-items-end m-3"
        type="submit"
        [disabled]=""
        (click)="updateItem(commandInfoSelect[0]); modal.dismiss('Cross click')"
      >
        Salvar
      </button>

      <input
        #allowExclude
        type="checkbox"
        id="allowExclude"
        name="allowExclude"
      />
      <label class="ms-3"> Liberar Exclusão</label>

      <ng-container *ngIf="allowExclude.checked">
        <button
          class="btn btn-sm btn-danger align-items-end m-3"
          type="submit"
          [disabled]=""
          (click)="
            excludeItem(commandInfoSelect[0]); modal.dismiss('Cross click')
          "
        >
          Excluir
        </button>
      </ng-container>
      <!-- <input type="checkbox" id="allowExclude" name="allowExclude" />
      <label class="ms-3"> Liberar Exclusão</label>
      <label class="ms-3" class="text-danger" *ngIf=""
        >Preencha todos os campos!</label
      >
      <label class="ms-2 text-danger" *ngIf=""
        >Númeração do modelo já existe</label
      >  -->
    </form>
    <div class="card">
      <p>
        Criado por: {{ commandInfoSelect[0].create_user }} -
        {{ commandInfoSelect[0].create_time }}
      </p>
      <p>
        Alterado por: {{ commandInfoSelect[0].update_user }} -
        {{ commandInfoSelect[0].update_time }}
      </p>
    </div>
  </div>
</ng-template>
<!--Fim Dialog-->

<!-- Dialog New -->
<ng-template #modalNewItem let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Adicionar um item</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <form id="formModelSelect" data-toggle="validator" role="form">
      <div class="row">
        <div class="row mb-3">
          <label>Selecione o Tipo</label>
            <div class="col-8">
              <div class="form-grouping">
                <ng-select 
                  [(ngModel)]="isAccessory">
                  <ng-option [value]="true">ACESSORIO</ng-option>
                  <ng-option [value]="false">DISPOSITIVO</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
      </div>
      <div class="row">
          <div class="row mb-3">
            <label>Selecione um Modelo</label>
            <div class="col-8">
              <div class="form-grouping">
                <ng-select 
                  id="deviceModelSelect"
                  [(ngModel)]="commandInfoSelect[0].dispositivoModelo"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="changeModel($event)"
                >
                  <ng-option
                    *ngFor="
                      let device of getAvaliableDeviceModel(
                        commandInfo,
                        commandInfoSelect[0].nome
                      )
                    "
                    [value]="device.dispositivoModelo"
                  >
                    {{ device.dispositivoModelo }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>        
      </div>
      <div class="row d-flex">
        <div class="col">
          <div class="row mb-3">
            <label>Selecione um Sistema</label>
            <div class="col-8">
              <div class="form-grouping">
                <ng-select
                  id="systemSelect"
                  [(ngModel)]="commandInfoSelect[0].sistemaAux"
                  [ngModelOptions]="{ standalone: true }"
                  [multiple]="true"
                >
                  <ng-option *ngFor="let system of systems" [value]="system">
                    {{ system }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row mb-3">
            <label>Selecione um Canal de envio</label>
            <div class="col-8">
              <div class="form-grouping">
                <ng-select
                  id="systemSelect"
                  [(ngModel)]="commandInfoSelect[0].canalEnvioId"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <ng-option
                    *ngFor="let canalEnvio of canalEnvioEnum; let i = index"
                    [value]="i + 1"
                  >
                    {{ canalEnvio }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">Copiar do modelo</div>
        <div class="col">
          <input
            class="form-check-input ms-2"
            type="checkbox"
            [(ngModel)]="ngIfCopyModel"
            checked="true"
            unchecked="false"
          />
        </div>
        <ng-container *ngIf="ngIfCopyModel">
          <div class="col">
            <div class="form-grouping">
              <ng-select
                id="copyModelSelect"
                (change)="copyModel($event, commandInfoSelect[0].nome)"
              >
                <ng-option
                  *ngFor="
                    let copyModel of getOtherItemsSameCommand(
                      commandInfo,
                      commandInfoSelect[0].nome
                    )
                  "
                >
                  {{ copyModel }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="form-grouping mb-2">
        <label for="formObservation" class="control-label">Observacao</label>
        <textarea
          id="formObservation"
          class="form-control"
          placeholder="Digite a observacao"
          type="text"
          name="itemObservation"
          [(ngModel)]="commandInfoSelect[0].observacao"
        >
        </textarea>
      </div>
      <div class="form-grouping">
        <label for="formObservationHTML" class="control-label"
          >ObservacaoHTML</label
        >

        <textarea
          id="formObservationHTML"
          class="form-control"
          placeholder="Digite a observacao HTML"
          type="text"
          name="itemObservationHTML"
          [(ngModel)]="commandInfoSelect![0].observacaoHTML"
        >
        </textarea>
        <div class="card mb-2">
          <span
            [innerHTML]="sanitizerHTML(commandInfoSelect![0].observacaoHTML)"
          >
          </span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="form-grouping m-2">
            <label for="formHasParam" class="control-label"
              >Tem parâmetro?</label
            >
            <input
              class="ms-2"
              type="checkbox"
              name="itemHasParam"
              [(ngModel)]="commandInfoSelect[0].valor"
            />
          </div>
        </div>
        <ng-container *ngIf="commandInfoSelect[0].valor">
          <div class="col">
            <div class="form-grouping m-2">
              <label for="formQtdParam" class="control-label"
                >Quantos parâmetros</label
              >
              <input
                type="number"
                class="form-control"
                name="itemQtdParam"
                [(ngModel)]="commandInfoSelect[0].quantidadeValor"
              />
            </div>
          </div>
        </ng-container>
      </div>
      <div class="row mb-3">
        <div class="form-grouping mb-2">
          <label for="formExemplo" class="control-label">Exemplo</label>
          <input
            id="formExample"
            class="form-control"
            placeholder="Digite um exemplo se houver"
            type="text"
            name="itemExample"
            [(ngModel)]="commandInfoSelect[0].exemplo"
          />
        </div>
      </div>

      <button
        class="btn btn-sm btn-success align-items-end m-3"
        type="submit"
        [disabled]=""
        (click)="insertItem(commandInfoSelect[0]); modal.dismiss('Cross click')"
      >
        Salvar
      </button>

      <label class="ms-3" class="text-danger" *ngIf=""
        >Preencha todos os campos!</label
      >
      <label class="ms-2 text-danger" *ngIf=""
        >Númeração do modelo já existe</label
      >
      <label class="ms-3" class="text-danger" *ngIf=""
        >Preencha todos os campos!</label
      >
      <label class="ms-2 text-danger" *ngIf=""
        >Númeração do modelo já existe</label
      >
    </form>
    <div class="card">
      <p>
        Criado por: {{ commandInfoSelect[0].create_user }} -
        {{ commandInfoSelect[0].create_time }}
      </p>
      <p>
        Alterado por: {{ commandInfoSelect[0].update_user }} -
        {{ commandInfoSelect[0].update_time }}
      </p>
    </div>
  </div>
</ng-template>
<!--Fim Dialog-->
